import React, {useState} from 'react';
import {Button, Checkbox, DatePicker, Form, Input} from 'antd'
import {MaskedInput} from 'antd-mask-input';

import {POLICY} from '../../config/routes';
import {IFormLoss} from '../../shared/forms/forms';
import {certRegex, phoneRegex} from '../../shared/helpers/regex';

interface FormProps {
    onComplete: (values:IFormLoss) => void
}

const LossForm = ({onComplete}: FormProps) => {

    const [form] = Form.useForm()
    const [termsAccepted, setTermsAccepter] = useState<boolean>(true)
    const [adAccepted, setadAccepter] = useState<boolean>(true)

    const onFinish = (values:IFormLoss) => {
        onComplete({
            ...values,
            termsAccepted,
            adAccepted,
        })
    }

    return (
        <Form form={form} layout={'vertical'} size={'large'} validateTrigger={'onSubmit'} onFinish={onFinish}>
            <Form.Item name={'FIO'} label={'ФИО'} rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <Input placeholder={'Иванов Иван Иванович'}/>
            </Form.Item>
            <Form.Item name={'Phone'} label={'Номер телефона'} rules={[
                {required: true, message: 'Заполните, пожалуйста'},
                {pattern: phoneRegex, message: 'Не соответствует формату номера телефона'}
            ]}>
                <MaskedInput mask={'+7 (000) 000-00-00'} placeholder={'+7 (999) 888-77-66'} size={'large'}/>
            </Form.Item>
            <Form.Item name={'Email'} label={'Email'} rules={[{required: true, message: 'Заполните, пожалуйста'}, {type: 'email', message: 'Не соответствует формату email'}]}>
                <Input placeholder={'name@example.com'}/>
            </Form.Item>
            <Form.Item name={'Certificate_Number'} label={'Номер сертификата'} rules={[
                {required: true, message: 'Заполните, пожалуйста'},
                {pattern: certRegex, message: 'Не соответствует формату номера сертификата'}
            ]}>
                <Input placeholder={'23000NSB176000000'}/>
            </Form.Item>
            <Form.Item name={'Certificate_Date'} label={'Дата выдачи сертификата'} rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <DatePicker format={'DD.MM.YYYY'}/>
            </Form.Item>
            <Form.Item name={'Comment'} label={'Причина обращения'} rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <Input.TextArea autoSize={{minRows:2, maxRows:6}}/>
            </Form.Item>

            <Form.Item>
                <Checkbox checked={termsAccepted} onChange={() => setTermsAccepter(!termsAccepted)}>Я ознакомился и соглашаюсь с <a href={POLICY} rel={'noreferrer'} target={'_blank'}>политикой
                    конфиденциальности</a> и <a href={POLICY} rel={'noreferrer'} target={'_blank'}>правилами обработки персональных данных</a></Checkbox>
            </Form.Item>
            <Form.Item>
                <Checkbox checked={adAccepted} onChange={() => setadAccepter(!adAccepted)}>Я соглашаюсь на получение информационных и рекламных материалов</Checkbox>
            </Form.Item>
            <Form.Item>
                <Button type={'primary'} htmlType={'submit'} disabled={!termsAccepted}>Заявить убыток</Button>
            </Form.Item>
        </Form>
    )
}

export default LossForm